import { IState } from "./state";
import { ActionTree, Store, ActionContext } from 'vuex';
import * as api from '../api';
import { ISearchParams } from "@/api";
import { router } from '../main';

type PayloadType = 'initApp' | 'setState' | 'search' | 'toggleValue' | 'setSearchQuery' | 'setCurrentPage' | 'clearFilters' | 'setSort'
export type ActionPayload<ActionData> = {
	type: PayloadType,
	payload: ActionData
}

type ActionHandler<ActionData> = (this: Store<IState>, injectee: ActionContext<IState, IState>, payload: ActionPayload<ActionData>) => any;
type ActionCreator<ActionData> = (data: ActionData) => ActionPayload<ActionData>;


export interface IValuePayload {
	name: string,
	value: string,
	selected: boolean
}
export interface ISetSearchQueryPayload {
	query: string,
	skipSearch?: boolean
}
export interface ISetCurrentPagePayload {
	page: number,
	skipSearch?: boolean
}
export interface IClearFiltersPayload {
	skipSearch?: boolean
}
export interface IToggleValuePayload {
	value: IValuePayload,
	skipSearch?: boolean
}

// Action creators
export const initApp: ActionCreator<IState> = (state) => ({
	type: 'initApp',
	payload: state
})
export const setSearchQuery: ActionCreator<ISetSearchQueryPayload> = (queryPayload) => ({
	type: 'setSearchQuery',
	payload: queryPayload
})
// Action handlers
const initAppAction: ActionHandler<IState> = ({ commit }, { payload }) => {
	commit({
		type: 'setState',
		payload
	})
}
export const toggleValue: ActionCreator<IToggleValuePayload> = (value) => ({
	type: 'toggleValue',
	payload: value
})
export const search: ActionCreator<boolean> = (reset) => ({
	type: 'search',
	payload: reset
})
export const setCurrentPage: ActionCreator<ISetCurrentPagePayload> = (payload) => ({
	type: 'setCurrentPage',
	payload: payload
})

export const clearFilters: ActionCreator<IClearFiltersPayload> = (payload) => ({
	type: 'clearFilters',
	payload
})



export const setSort: ActionCreator<string> = (string) => ({
	type: 'setSort',
	payload: string
})
const setSortAction: ActionHandler<string> = ({ commit, dispatch }, { payload }) => {
	commit({
		type: 'setSort',
		payload
	})
	dispatch(search(true))
}

const clearFiltersAction: ActionHandler<IClearFiltersPayload> = ({ commit, dispatch, getters }, { payload }) => {
	commit({
		type: 'clearFilters',
		payload
	})
	router.replace({
		query: getters.getParams
	})
	if(!payload.skipSearch) {
		dispatch(search(true))
	}
	
}
const toggleValueAction: ActionHandler<IToggleValuePayload> = ({ commit, dispatch }, { payload }) => {
	commit({
		type: 'toggleValue',
		payload: payload.value
	})
	if(!payload.skipSearch) {
		dispatch(search(true))
	}
	
}
const setSearchQueryAction: ActionHandler<ISetSearchQueryPayload> = ({ commit, dispatch }, { payload }) => {
	commit({
		type: 'setSearchQuery',
		payload: payload.query
	})
	if(!payload.skipSearch) {
		dispatch(search(true))
	}
	
}
const setCurrentPageAction: ActionHandler<ISetCurrentPagePayload> = ({ commit, dispatch, state }, { payload }) => {

	commit({
		type: 'setCurrentPage',
		payload: payload.page
	})
	if(!payload.skipSearch) {
		dispatch(search(false))
	}
	


}
const searchAction: ActionHandler<boolean> = ({ commit, state, getters }, { payload }) => {

	if(payload) {
		commit({
			type: 'resetPage',
			payload: undefined
		})
	}

	// Get the identifier from filter and its selected values, use in searchParams
	const categoryFilters = state.categoryFilters.map(cf => {
		return {
			identifier: cf.identifier,
			values: cf.values.filter(v => v.selected).map(v => v.value)
		}
	})
	const sort = state.sort.find(s => s.active);

	// searchParams get the query from state, categoryFilters from above, 
	const searchParams = {
		query: state.query,
		categories: categoryFilters,
		page: state.page,
		sort: sort
	} as ISearchParams

	// Endpoint = ur to search route
	// Send the news hits in the result and the total amount to mutaions
	api.search(state.endpoints.search, searchParams)
		.then(result => {
			commit({
				type: 'setJobs',
				payload: result.jobs
			})
			commit({
				type: 'setTotal',
				payload: result.total
			})
			commit({
				type: 'setPages',
				payload: Math.ceil(Number(state.total) / Number(state.count))
			})
		});
}

const actions: ActionTree<IState, IState> = {
	initApp: initAppAction,
	toggleValue: toggleValueAction,
	setSearchQuery: setSearchQueryAction,
	search: searchAction,
	setCurrentPage: setCurrentPageAction,
	clearFilters: clearFiltersAction,
	setSort: setSortAction,
}

export default actions;
